import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/Layout.vue";
import LoginView from "@/views/login/LoginView.vue";
import OtpView from "@/views/login/OtpView.vue";
import ResetView from "@/views/user/ResetView.vue";
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/Otp',
        name: "OtpView",
        component:OtpView
    },
    {
        path: '/ResetView',
        name: "ResetView",
        component:ResetView
    },
    {
        path: '/project-documentation',
        name: "ProjectDocumentation",
        component: () => import('@/views/ProjectDocumentation.vue')
    },
    {
        path: '/',
        name: "login",
        component:LoginView
    },
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '/dashboard',
                name: "TransactionManager",
                meta: { requiresAuth: true },
                component: () => import('@/views/TransactionManager.vue')
            },
            {
                path: '/UserManagment',
                name: "UserManagment",
                meta: { requiresAuth: true },
                component: () => import('@/views/user/UserManagment.vue')
            },
            {
                path: '/reset-Password',
                name: "KazangResetPassword",
                meta: { requiresAuth: true },
                component: () => import('@/views/kazang/KazangResetPassword.vue')
            },
            {
                path: '/reset-initialization',
                name: "KazangInitialization",
                meta: { requiresAuth: true },
                component: () => import('@/views/kazang/KazangInitialization.vue')
            },
            {
                path: '/KazangAccountDetails',
                name: "KazangAccountDetails",
                meta: { requiresAuth: true },
                component: () => import('@/views/kazang/KazangAccountDetials.vue')
            },
            {
                path: '/form-management',
                name: "FormManagement",
                meta: { requiresAuth: true },
                component: () => import('@/views/Form.vue')
            },
            {
                path: '/Settings',
                name: "Settings",
                meta: { requiresAuth: true },
                component: () => import('@/views/Settings.vue')
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    // const isAuthenticated = store.getters['getCurrentUser'];
    const isAuthenticated = sessionStorage.getItem('session');
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next('/');
        } else {
            next();
        }
    } else {
        next();
    }
});
export default router
